export default "__VITE_ASSET__x2DQWUmZ__"